"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compass() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2505" id="our-ethical-compass" className="bg-paper text-foreground relative overflow-hidden py-24 md:py-32 lg:py-[200px]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: "repeating-radial-gradient(circle at 30% 40%, var(--primary) 0, var(--primary) 1px, transparent 1px, transparent 38px), repeating-radial-gradient(circle at 70% 60%, var(--primary) 0, var(--primary) 1px, transparent 1px, transparent 52px)"
    }} />

      <div className="relative mx-auto w-full max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={leftRef} className={`lg:col-span-6 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-10 md:mb-14">
              <span className="font-default text-xs md:text-sm font-medium uppercase tracking-[0.1em] pb-1 border-b-2" style={{
              borderColor: "var(--accent)"
            }}>
                01 / Our Philosophy
              </span>
            </div>

            {}
            <h2 className="font-default font-semibold uppercase leading-[0.95] tracking-tighter text-[56px] sm:text-[72px] md:text-[96px] lg:text-[120px]">
              <span className="block">Guided</span>
              <span className="block">By</span>
              <span className="relative inline-block">
                *Integrity*
                <span aria-hidden="true" className="absolute left-0 -bottom-2 md:-bottom-3 h-[6px] md:h-[10px]" style={{
                width: "108%",
                backgroundColor: "var(--accent)"
              }} />
              </span>
            </h2>

            {}
            <div className="mt-12 md:mt-14 max-w-[480px] font-sans text-[18px] leading-[1.65] text-secondary space-y-6">
              <p className="relative">
                <span className="font-default font-bold float-left mr-3 leading-[0.85] text-[72px] md:text-[96px]" style={{
                color: "var(--accent)"
              }}>
                  T
                </span>
                <span className="font-default font-semibold uppercase tracking-wide text-foreground">ax compliance</span>{" "}
                is more than just filing forms; it is the foundation of your financial security. We approach every return with the precision of an architect and the care of a partner.
              </p>
              <p>
                At Lovejoy Company, we believe that clarity is the ultimate luxury. We strip away the complexity of tax codes to provide you with actionable insights that protect your wealth and support your long-term goals.
              </p>
              <p>
                This is our commitment: to provide rigorous, ethical, and proactive guidance that stands the test of any audit.
              </p>
            </div>

            {}
            <div className="mt-14 md:mt-16 border-t border-border pt-8 max-w-[520px]">
              <div className="flex flex-col gap-3">
                <span className="font-default text-xs font-medium uppercase tracking-[0.2em] text-secondary">
                  Our Promise
                </span>
                <p className="font-serif italic text-[18px] md:text-[20px] leading-snug">
                  &ldquo;We treat every client's financial future with the same diligence we would apply to our own.&rdquo;
                </p>
                <div className="flex items-center gap-3 mt-1">
                  <span aria-hidden="true" className="font-serif italic text-2xl" style={{
                  color: "var(--accent)"
                }}>
                    ~
                  </span>
                  <span className="font-default text-[11px] font-bold uppercase tracking-[0.18em]" style={{
                  color: "var(--accent)"
                }}>
                    The Lovejoy Team
                  </span>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-6 relative transition-all duration-1000 ease-out delay-150 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="relative max-w-[88%]">
              <div className="relative">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/tax_professional_reviewing_documents.png" alt="Professional tax advisor reviewing financial documents with focus" loading="lazy" decoding="async" className="block w-full h-[360px] md:h-[440px] lg:h-[480px] object-cover" />
              </div>
            </div>

            {}
            <div className="my-10 md:my-12 lg:ml-20 max-w-[360px]">
              <p className="font-serif italic text-[15px] md:text-[16px] leading-snug text-secondary pb-2 border-b inline-block" style={{
              borderColor: "var(--accent)"
            }}>
                Precision in every detail, Lovejoy Company office
              </p>
            </div>

            {}
            <div className="relative lg:ml-20 lg:-mr-16 xl:-mr-24">
              <div className="relative">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1718253/img/modern_financial_office_architecture.webp" alt="Clean, modern office architecture representing financial clarity" loading="lazy" decoding="async" className="block w-full h-[420px] md:h-[500px] lg:h-[560px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}